<div class="container-fluid bg-gold-gradient py-5 position-relative overflow-hidden dp-hero">
  <div class="container ">
    <div class="row align-items-start">
      <!-- LEFT -->
      <div class="col-lg-5 text-dark">
        <img src="assets/img/d-and-p-2.png" class="img-fluid w-30 mb-5 " alt="Deals & Pobs" />
        <!-- Heading -->
        <h1 class="display-5 fw-bold lh-sm mb-5">
          Welcome to D&P<br />
          Big savings. Great pubs.
        </h1>
        <h4 class="fw-semibold mb-3">Our most popular pubs</h4>

        <div class="row justify-content-center justify-content-md-start text-center g-3">

          <div class="col-4 col-md-auto d-flex flex-column align-items-center">
            <div class="d-flex align-items-center justify-content-center icon-box">
              <img src="https://cdn-icons-png.flaticon.com/128/9763/9763986.png" class="img-fluid small-icon-box"
                alt="">
            </div>
            <span class="badge rounded-pill bg-dark text-warning px-3 py-2 mt-2">
              The Tipsy Barrel
            </span>
          </div>

          <div class="col-4 col-md-auto d-flex flex-column align-items-center">
            <div class="d-flex align-items-center justify-content-center icon-box">
              <img src="https://cdn-icons-png.flaticon.com/128/600/600388.png" class="img-fluid small-icon-box" alt="">
            </div>
            <span class="badge rounded-pill bg-dark text-warning px-3 py-2 mt-2">
              Brew House
            </span>
          </div>

          <div class="col-4 col-md-auto d-flex flex-column align-items-center">
            <div class="d-flex align-items-center justify-content-center icon-box">
              <img src="https://cdn-icons-png.flaticon.com/128/3993/3993988.png" class="img-fluid small-icon-box"
                alt="">
            </div>
            <span class="badge rounded-pill bg-dark text-warning px-3 py-2 mt-2">
              Drunk & Panda
            </span>
          </div>

        </div>

      </div>

      <!-- RIGHT -->
      <!-- RIGHT -->
<div class="col-lg-7 mt-0 mt-lg-0 p-0">
  @if (placementsData['Homepage']?.length) {
    @for (item of placementsData['Homepage']; track item) {

      <div
        class="card border-0 rounded-4 overflow-hidden shadow-sm mb-3 w-100 mt-5 position-relative"
      >

        <!-- Image -->
        <a
          class="mb-0 text-decoration-none d-block"
          [routerLink]="['/pubs/view', item.id]"
          target="_blank"
          rel="noopener"
        >
          <img
            [src]="item.imageUrl"
            class="w-100 object-fit-cover rounded-4 hero-height"
            alt="The Tipsy Barrel"
          />

          <!-- Rating -->
          <span
            class="position-absolute top-0 end-0 m-3 badge rounded-pill bg-dark text-warning px-3 py-2 shadow z-3"
          >
            <i class="fa-solid fa-star me-1 small"></i> {{ item.rating || '4.5' }}
          </span>

          <!-- Title + Gradient -->
          <div
            class="position-absolute bottom-0 start-0 w-100 p-4 gradient-overlay z-1"
            
          >
            <span class="fw-bold text-white fs-5">
              {{ item.title }}
            </span>
          </div>

        </a>
      </div>

    }
  }
</div>


    </div>
  </div>
  <!-- Bottom Curve -->
  <div class="hero-curve bg-white d-none d-lg-block"></div>
</div>
<!-- <section>2</section> -->
<div class="container-fluid">
  <div class="container py-5">
    <h2 class="text-center fw-semibold mb-5">Yours Brewery & Pubs</h2>
    @if (placementsData['Deals Section']?.length) {
    <div class="row g-4">
      <!-- CARD -->
      @for (item of placementsData['Deals Section']; track item) {
      <!-- CARD -->
      <div class="col-12 col-md-6 col-lg-4">
        <div class="card border-0 rounded-4 overflow-hidden shadow-sm h-100">

          <!-- Image -->
          <a class="mb-0 text-white fw-bold flex-grow-1 text-dark text-decoration-none"
            [routerLink]="['/pubs/view', item.id]" target="_blank" rel="noopener">
            <div class="position-relative">
              <img [src]="item.imageUrl" class="w-100 object-fit-cover h-260" alt="Nightlife" />

              <!-- Overlay Text -->
              <div class="position-absolute bottom-0 start-0 w-100 p-3 gradient-overlay">
                <span class="fw-medium flex-grow-1">
                  {{ item.title }}
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>
<!-- <section>3</section> -->
<div class="container py-5">
  <div class="row g-4 align-items-start">

    <!-- LEFT DEAL LIST -->
    @if (placementsData['Sidebar']?.length) {
    <div class="col-lg-8">
      <!-- Deal Item -->
      @for (item of placementsData['Sidebar']; track item) {
      <a [routerLink]="['/pubs/view', item.id]" target="_blank" rel="noopener" class="d-flex align-items-center mb-4 rounded-4 border deal-card
            text-decoration-none text-dark">

        <!-- Image -->
        <img [src]="item.imageUrl" class="deal-no3-img rounded-3 flex-shrink-0" alt="" />

        <!-- Title -->
        <span class="fw-medium flex-grow-1 ms-3">
          {{ item.title }}
        </span>

        <!-- Arrow -->
        <i class="fa-solid fa-angle-right me-3"></i>

      </a>
      }
    </div>
    }
    <!-- RIGHT PROMO CARD -->
    @if (placementsData['Homepage']?.length) {
    <div class="col-lg-4">
      <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner section-height rounded-4">
          @for (item of placementsData['Homepage']; track item; let i = $index) {
          <div class="carousel-item h-100" [class.active]="i === 0">

            <!-- CLICKABLE -->
            <a [routerLink]="['/pubs/view', item.id]" target="_blank" rel="noopener"
              class="d-block w-100 h-100 text-decoration-none">
              <img [src]="item.imageUrl" class="d-block w-100 h-100 object-fit-cover" alt="{{ item.title }}" />

              <div class="carousel-caption d-none d-md-block">
                <h5 class="text-white">
                  {{ item.title }}
                </h5>
              </div>
            </a>

          </div>
          }
        </div>
        <!-- Controls -->
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions"
          data-bs-slide="prev">
          <span class="carousel-control-prev-icon"></span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions"
          data-bs-slide="next">
          <span class="carousel-control-next-icon"></span>
        </button>
      </div>
    </div>
    }
  </div>
</div>